<template lang="pug">
#app.font-rubik
  header.flex.items-center
    .container
      a.back.flex.items-center.text-sm.leading-4.font-semibold(href="https://ru.coral.club/")
        .icon
          img(src="@/assets/img/arrow.svg")
        span Вернуться на Coral Club

  section.section-1.pt-16.pb-12
    .container.flex
      .left(class="w-1/12")
        .line
      .right(class="w-11/12")
        .small-title.uppercase.font-medium Онлайн-аккредитация
        .title.font-bebas.my-7 Для представителей средств массовой информации и лидеров мнений
        .text.mb-7.text-lg.opacity-70 Мы рады делиться нашей экспертизой с представителями медиа.
        button.w-full.h-20.bg-red.flex.px-10.text-sm.font-semibold.text-white.justify-between.items-center(
          class="hover:bg-red-light",
          v-scroll-to="'#section-8'"
        ) Онлайн-аккредитация
          .icon
            img(src="@/assets/img/arrow-white.svg")

  section.section-2
    .img
      img(src="@/assets/img/section-2--bg.jpg")

  section.section-3.py-20(class="md:pt-40 md:pb-20")
    .container.flex.flex-wrap
      .left.w-full(class="lg:w-3/12")
        .small-title.text-xs.letter-spacing-max.uppercase.font-medium СМИ
      .right.w-full(class="lg:w-9/12")
        .title.font-semibold.mb-12 Компания Coral Club — эксперт в теме здорового образа жизни
        .flex.flex-wrap.justify-between
          .text Для подготовки комментариев и статей, организации работы со спикерами, проведения съемок на территории офисов продаж и внешних площадках, пожалуйста, направляйте запрос, указывая всю необходимую информацию.
          //- .text.font-semibold «Авторами в статьях на тему здорового образа жизни выступают эксперты с многолетним опытом в медицине».

  section.section-4
    .container.flex.items-center.flex-col.justify-center(
      class="sm:flex-row sm:justify-between"
    )
      .title.font-semibold.text-white.mb-4(class="sm:mb-0") Готовы с нами пообщаться?
      button.w-full.h-20.bg-white.flex.px-9.text-sm.font-semibold.text-black.justify-between.items-center(
        v-scroll-to="'#section-8'"
      ) Онлайн-аккредитация
        .icon
          img(src="@/assets/img/arrow.svg")

  section.section-5.py-20(class="md:py-40")
    .container.flex.flex-wrap.justify-between
      .left(class="sm:w-full md:w-7/12 lg:w-5/12")
        .title.font-semibold Приглашаем к сотрудничеству инфлюенсеров
        .bottom.mt-8.flex.justify-between(class="sm:mt-16 md:mt-32")
          .left(class="basis-1/3")
            .small-title.uppercase.font-medium.text-xs.font-medium.leading-7.letter-spacing-max Лидерам мнений
          .right(class="basis-2/3")
            .text.leading-7 Если вы так же, как и мы, хотите помогать людям делать разумный выбор в пользу заботы о здоровье, будем рады видеть вас в команде инфлюенсеров Coral Club. Мы в поиске интересных блогов о здоровье, нутрициологии, фитнесе и красоте.
      .right.mt-16(class="sm:w-full md:w-4/12 lg:w-6/12 md:mt-0")
        .img
          img(src="@/assets/img/section-5--img.jpg")

  section.section-6.py-20(class="md:py-32")
    .container.flex.flex-wrap.justify-between
      .left.w-full(class="sm:w-full md:w-6/12 sm:mb-5")
        .text.font-semibold «Мы ждем лидеров мнений, способных вдохновлять аудиторию и через личный опыт транслировать знания о продуктах Coral Club. Наша стратегическая задача — собрать вокруг бренда Coral Club всех, кого так же, как и нас, вдохновляет тема здоровья».
      .right(class="sm:w-full md:w-5/12")
        .text.text-lg.leading-8 Расскажите нам про свой блог — заполните форму обратной связи на этой странице.
        button.w-full.h-20.bg-red.flex.px-9.text-sm.font-semibold.text-white.justify-between.items-center.mt-16(
          class="hover:bg-red-light",
          v-scroll-to="'#section-8'"
        ) Онлайн-аккредитация
          .icon
            img(src="@/assets/img/arrow-white.svg")

  section.section-7.py-20(class="md:py-32")
    .container.flex
      .left(class="md:w-1/12 lg:w-2/12")
        .line
      .right.w-full(class="md:w-11/12 lg:w-8/12")
        .small-title.uppercase.text-xs.font-medium.letter-spacing-max больше информации о нас
        .title.font-semibold.my-12 Хотите узнать о нас больше?
        .list-link
          a.link-item.flex.items-center.justify-between(
            href="https://ru.coral.club/company/"
            target="_blank"
          )
            span.text-2xl Компания Coral Club
            .icon
              img(src="@/assets/img/arrow.svg")
          a.link-item.flex.items-center.justify-between(
            href="https://ru.coral.club/news/smi/"
            target="_blank"
          )
            span.text-2xl О нас пишут
            .icon
              img(src="@/assets/img/arrow.svg")

        .pt-6.text-sm.font-medium Мы в социальных сетях
        .social-links.flex.mt-2
          a.social-item(
            href="https://t.me/joinchat/QkZVL3ukKEO-MG76"
            target="_blank"
          )
            svg.
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.92999 17.841L10.1916 14.1078L17.3628 7.99981C17.6808 7.72621 17.298 7.59421 16.8828 7.83181L8.02559 13.119L4.19999 11.9706C3.37799 11.7498 3.36959 11.211 4.38719 10.8234L19.2948 5.38741C19.9764 5.09581 20.6304 5.54581 20.3688 6.5346L17.8296 17.841C17.652 18.6438 17.1384 18.8382 16.4292 18.4674L12.564 15.7662L10.7064 17.4702C10.6124 17.5855 10.494 17.6785 10.3597 17.7426C10.2255 17.8067 10.0787 17.8403 9.92999 17.841V17.841Z" fill="#413D58"/></svg>
          a.social-item(
            href="https://youtube.com/user/cciofficial"
            target="_blank"
          )
            svg.
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z" fill="#413D58"/></svg>
          //- a.social-item(
          //-   href=" https://instagram.com/coralclub?utm_medium=copy_link"
          //-   target="_blank"
          //- )
          //-   svg.
          //-     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z" fill="#413D58"/></svg>


  section#section-8.section-8.py-24
    .container
      .title.font-semibold.mb-12 Онлайн-аккредитация
      form.mx-auto(class="sm:w-full md:w-10/12 lg:w-8/12 xl:w-6/12" v-if="!success")
        .checkboxes.flex.flex-col.mb-8
          label(for="smi", :class="{ active: role == 'smi' }")
            input#smi(type="radio", name="SMI", value="smi", v-model="role")
            | Я представитель СМИ
          label(for="leader", :class="{ active: role == 'leader' }")
            input#leader(
              type="radio",
              name="LEADER",
              value="leader",
              v-model="role"
            )
            | Я лидер мнений
        .flied.mb-8(
          :class="{ error: errors.errorName }",
          v-if="role != 'leader'"
        )
          input(type="text", :class="{ active: name }", v-model="name")
          span Название СМИ*
          span.error Обязательно для заполнения
        .flied.mb-8(
          :class="{ error: errors.errorEmail }",
          v-if="role != 'leader'"
        )
          input(type="text", :class="{ active: email }", v-model="email")
          span Email*
          span.error Введите адрес e‑mail
        .flied.mb-8(
          :class="{ error: errors.errorAccount }",
          v-if="role != 'smi'"
        )
          input(type="text", :class="{ active: account }", pattern='http[s]?://', v-model="account")
          span Ссылка на аккаунт*
          span.error Введите ссылку в формате http, https или www
        .flied.mb-8(
          :class="{ error: errors.errorTheme }",
          v-if="role != 'smi'"
        )
          input(type="text" :class="{ active: theme }", v-model="theme")
          span Тематика блога

        .flied.mb-8(:class="{ error: errors.errorPhone }", class="error-phone")
          the-mask(
            type="text",
            :class="{ active: phone }",
            v-model="phone",
            mask="+7-(###)-###-##-##",
            required
          )
          span Телефон*
          span.error.type-1 Пожалуйста, заполните это поле
          span.error.type-2 Неверный телефон
        .flied.mb-8(:class="{ error: errors.errorComment }")
          input(type="text", maxlength=300, :class="{ active: comment }", v-model="comment")
          span Комментарий

        button.w-full.h-20.bg-red.flex.py-5.px-9.text-sm.font-semibold.text-white.justify-between.items-center.mt-16(
          class="hover:bg-red-light",
          @click.prevent="sendForm"
        )
          span Отправить запрос
          .icon
            img(src="@/assets/img/arrow-white.svg")

      .successMessage.mx-auto.my-48(class="sm:w-full md:w-10/12 lg:w-8/12 xl:w-6/12" v-if="success")
        .successTitle Cообщение отправлено!
        .successText Мы свяжемся с вами в течение 24 часов.
        a.back.flex.items-center.justify-center.text-sm.leading-4.font-semibold.mt-8(@click.prevent="backForm")
          .icon
            img(src="@/assets/img/arrow.svg")
          span Вернуться на Coral Club

</template>

<script>

export default {
  name: "App",
  components: {

  },
  data() {
    return {
      arData: [],
      role: "smi",
      name: "",
      email: "",
      phone: "",
      comment: "",
      account: "",
      theme: "",
      errors: {
        errorName: false,
        errorEmail: false,
        errorPhone: false,
        errorAccount: false,
        errorTheme: false,
        errorComment: false,
      },
      error: false,
      success: false,
    };
  },
  methods: {
    async sendForm() {
      if (!this.name && this.role == "smi") {
        this.errors.errorName = true;
        this.error = true;
      }
      if (!this.email && this.role == "smi") {
        this.errors.errorEmail = true;
        this.error = true;
      } else if (this.role == "smi") {
        let pattern =
          //eslint-disable-next-line
          /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if (!pattern.test(this.email)) {
          this.errors.errorEmail = true;
          this.error = true;
        } else {
          this.errors.errorEmail = false;
          this.error = false;
        }
      }

      if (!this.phone || this.phone.length !== 10) {
        this.errors.errorPhone = true;
        this.error = true;
      }
      if (
          this.role !== "smi" && (
              !this.account ||
              !this.account.match(/^http[s]?:\/\//i)
          )
      ) {
        this.errors.errorAccount = true;
        this.error = true;
      }
      if (this.comment?.length > 300) {
        this.errors.errorComment = true;
        this.error = true;
      }


      //console.log(this.errors);

      if (!this.error) {
        this.arData = {
          role: this.role,
          name: this.name,
          email: this.email,
          phone: this.phone,
          account: this.account,
          theme: this.theme,
          comment: this.comment,
        };

        const response = await this.$axios.post(`/ajax/for-smi/`, {
          arData: this.arData,
        });

        //console.log('response', response)

        if (response.data == "sent") {
          this.success = true;
          this.name = "";
          this.email = "";
          this.phone = "";
          this.comment = "";
          this.account = "";
          this.theme = "";
        }
      }
    },
    backForm() {
      this.success = false;
    },
  },
  watch: {
    name(newValue) {
      if (newValue != "") {
        this.errors.errorName = false;
        this.error = false;
      }
    },
    email(newValue) {
      if (newValue != "") {
        this.errors.errorEmail = false;
        this.error = false;
      }
    },
    phone(newValue) {
      if (newValue != "") {
        this.errors.errorPhone = false;
        this.error = false;
      }
    },
    account(newValue) {
      if (newValue != "") {
        this.errors.errorAccount = false;
        this.error = false;
      }
    },
  },
};
</script>

<style lang="sass">
#app
  background: $white
</style>
